<div class="asset-container bg-white pb-3 pb-sm-5" id="overview" *ngIf="(assetDetail.productDetail$ | async) as productDetail">

  <h4 class=" d-block pt-5 pb-3  font-weight-bold">
    Overview
  </h4>
  <div Markdown [data]="productDetail.detail.long_description"></div>
  <br />

  <div class="d-flex flex-wrap">
    <div class="tag--item" aihubFlexlistItem *ngFor="let tag of tags">{{tag}}</div>
  </div>
</div>
